<template>
  <v-container fluid>
    <v-toolbar color="white" flat>
      <v-toolbar-title>Clientes</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-card-title>
        <v-text-field
          v-model="Pesquisa"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
    </v-toolbar>
    <v-data-table
      :key="dataTableKey"
      :headers="headers"
      :search="Pesquisa"
      :items="data"
      :loading="loading"
      :items-per-page="10"
      class="elevation-1"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-row
          style="padding-left: 5px !important; padding-top: 0px !important;  padding-bottom: 0px !important;"
        >
          <span style="margin-right: 10px;">
            <v-icon small @click="editItem(item)">edit</v-icon></span
          >
          <span> <v-icon small @click="deleteItem(item)">delete</v-icon></span>
        </v-row>
      </template>
      <template v-slot:[`item.ativar`]="{ item }">
        <v-icon small @click="ativar(item)">link</v-icon>
      </template>
      <template v-slot:[`item.resetpassword`]="{ item }">
        <v-icon small @click="resetpassword(item)">link</v-icon>
      </template>
      <template v-slot:[`item.ativoemail`]="{ item }">
        <v-chip
          v-if="!item.ativoemail"
          class="ma-2"
          color="red"
          text-color="white"
        >
          Inativo
        </v-chip>
        <v-chip
          v-if="item.ativoemail"
          class="ma-2"
          color="green"
          text-color="white"
        >
          Ativo
        </v-chip>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" persistent max-width="1200">
      <v-card class="card-rounded">
        <v-form @submit.prevent="onSave" ref="clienteForm" lazy-validation>
          <v-card-title>
            Clientes
          </v-card-title>
          <v-card-text>
            <v-tabs v-model="tab">
              <v-tab :key="'tab1'">
                Dados
              </v-tab>
              <v-tab :key="'tab2'">
                Histórico saldo
              </v-tab>
              <v-tab :key="'tab3'">
                Indicações Cliente
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item :key="'tab1'">
                <v-card flat>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="4" xl="4" lg="4" md="6" sm="6">
                        <v-text-field
                          v-model="profile.nome"
                          label="Nome"
                          :rules="nomeRules"
                          required
                        ></v-text-field> </v-col
                      ><v-col cols="4" xl="4" lg="4" md="6" sm="6">
                        <v-text-field
                          v-model="profile.email"
                          label="E-mail"
                          :rules="emailRules"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2" xl="2" lg="2" md="6" sm="6">
                        <v-text-field
                          v-model="dtAniversario"
                          v-mask="'##/##/####'"
                          label="Aniversário"
                          :rules="dtAniversarioRules"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                        <v-text-field
                          v-model="profile.telefone"
                          label="Telefone"
                          :rules="telefoneRules"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                        <v-text-field
                          v-model="profile.cpf"
                          v-mask="'###.###.###-##'"
                          label="CPF"
                          :rules="cpfRules"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                        <v-switch
                          :key="ativoKey"
                          v-model="profile.ativo"
                          class="ma-2"
                          label="Ativo"
                        ></v-switch>
                      </v-col>
                      <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                        <v-text-field
                          v-model="profile.banco"
                          label="Banco"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                        <v-text-field
                          v-model="profile.agencia"
                          label="Agência"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                        <v-text-field
                          v-model="profile.conta"
                          label="Conta"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                        <v-select
                          :items="tiposConta"
                          label="Tipo da conta"
                          item-text="label"
                          item-value="value"
                          v-model="profile.tipoConta"
                        ></v-select>
                      </v-col>
                      <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                        <v-text-field
                          v-model="profile.cep"
                          label="Cep"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                        <v-text-field
                          v-model="profile.rua"
                          label="Rua"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                        <v-text-field
                          v-model="profile.bairro"
                          label="Bairro"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                        <v-text-field
                          v-model="profile.estado"
                          label="Estado"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                        <v-text-field
                          v-model="profile.numero"
                          label="Número"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                        <v-text-field
                          v-model="profile.complemento"
                          label="Complemento"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" xl="3" lg="3" md="6" sm="6">
                        <v-text-field
                          v-model="profile.cidade"
                          label="Cidade"
                        ></v-text-field>
                      </v-col>
                    </v-row> </v-container
                ></v-card>
              </v-tab-item>

              <v-tab-item :key="'tab2'">
                <v-card flat>
                  <v-container fluid>
                    <v-row>
                      <v-spacer></v-spacer>
                      <span>Saldo: </span>
                      <span
                        v-if="saldoCliente >= 0"
                        style="padding-right:10px; color:#4bcf13;"
                      >
                        {{ formatValue(saldoCliente, "E") }}</span
                      >
                      <span v-else style="padding-right:10px; color:#bd0909;">
                        {{ formatValue(saldoCliente, "S") }}</span
                      >
                    </v-row>
                    <v-data-table
                      class="dtbMovimento"
                      :key="dtbMovimentosKey"
                      :headers="movimentoCarteiraHeaders"
                      :items="lstDatasMovimentoCarteira"
                      :loading="loadingMovimentoCarteira"
                      item-key="id"
                      group-by="data"
                      :items-per-page="10"
                    >
                      <template v-slot:[`item.valor`]="{ item }">
                        <span v-if="item.tipo == 'S'" style="color:#bd0909">{{
                          formatValue(item.valor, item.tipo)
                        }}</span>
                        <span
                          v-else-if="item.tipo == 'SP'"
                          style="color:#BD7509"
                          >{{ formatValue(item.valor, "S") }}</span
                        >
                        <span
                          v-else-if="item.tipo == 'E'"
                          style="color:#4bcf13"
                          >{{ formatValue(item.valor, item.tipo) }}</span
                        >
                        <span
                          v-else-if="item.tipo == 'EP'"
                          style="color:#BD7509"
                          >{{ formatValue(item.valor, "E") }}</span
                        >
                      </template>
                      <template v-slot:[`item.tipo`]="{ item }">
                        <span v-if="item.tipo == 'S'">Saída</span>
                        <span v-if="item.tipo == 'SP'">Saída Pendente</span>
                        <span v-if="item.tipo == 'E'">Entrada</span>
                        <span v-if="item.tipo == 'EP'">Entrada Pendente</span>
                      </template>
                    </v-data-table>
                  </v-container>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="'tab3'">
                <v-card flat>
                  <v-container fluid>
                    <v-data-table
                      class="dtbMovimento"
                      :key="dtbIndicacoesKey"
                      :headers="headersIndicacoes"
                      :items="indicacoes"
                      :loading="loadingIndicacoes"
                      :items-per-page="10"
                    >
                      <template v-slot:[`item.valor`]="{ item }">
                        <span>{{
                          item.valor.toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}</span>
                      </template>
                      <template v-slot:[`item.premium`]="{ item }">
                        <span>{{ item.premium == 1 ? "Sim" : "Não" }}</span>
                      </template>
                    </v-data-table>
                  </v-container>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false"
              >Fechar</v-btn
            >
            <v-btn color="blue darken-1" text @click="onSave">Salvar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <app-delete-dialog
      msg="Deseja Remover o cliente selecionado? Esta ação é irreversível "
      :dialogDelete="deleteDialog"
      :id="selectedId"
      @onConfirmDelete="onConfirmDelete($event)"
      @onCancelDelete="onCancelDelete()"
    ></app-delete-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import http from "../../service/data-service";
import DeleteDialog from "../delete/DeleteDialog.vue";
import Util from "../../service/util-service";
import { mask } from "vue-the-mask";

export default {
  components: {
    "app-delete-dialog": () => Promise.resolve(DeleteDialog),
  },
  directives: { mask },
  data() {
    return {
      data: [],
      tab: null,
      deleteDialog: false,
      ativoKey: 0,
      selectedId: 0,
      loading: false,
      vdt: "",
      Pesquisa: "",
      lstDatasMovimentoCarteira: [],
      dtbMovimentosKey: 0,
      dtbIndicacoesKey: 0,
      saldoCliente: 0,
      movimentoCarteiraHeaders: [
        {
          text: "Data",
          align: "start",
          value: "data",
        },
        {
          text: "Descrição",
          align: "start",
          value: "descricao",
          groupable: false,
        },
        {
          text: "Status",
          align: "start",
          value: "tipo",
          groupable: false,
        },
        {
          text: "Valor",
          align: "end",
          value: "valor",
          groupable: false,
        },
      ],
      loadingMovimentoCarteira: false,
      loadingIndicacoes: false,
      headers: [
        { text: "Ações", value: "actions", sortable: false },
        {
          text: "Nome",
          align: "start",
          value: "nome",
        },
        {
          text: "E-mail",
          align: "start",
          value: "email",
        },
        {
          text: "Telefone",
          value: "telefone",
        },
        {
          text: "CPF",
          value: "cpf",
        },
        {
          text: "E-mail Ativo",
          value: "ativoemail",
        },
        {
          text: "Ativar Conta",
          value: "ativar",
        },
        {
          text: "Resetar Senha",
          value: "resetpassword",
        },
      ],
      headersIndicacoes: [
        {
          text: "Cliente",
          align: "start",
          value: "nome",
        },
        {
          text: "Valor",
          align: "start",
          value: "valor",
        },
        {
          text: "Premium",
          align: "start",
          value: "premium",
        },
      ],

      tiposConta: [
        { label: "Conta Poupança", value: "CP" },
        { label: "Conta Corrente", value: "CC" },
      ],
      dialog: false,
      dataTableKey: 0,
      editedProfile: null,
      profile: {},
      dtAniversario: "",
      dtAniversarioRules: null,
      telefoneRules: null,
      nomeRules: null,
      emailRules: null,
      cpfRules: null,
      indicacoes: [],
    };
  },
  computed: {
    ...mapGetters({
      session: "session",
    }),
  },
  watch: {
    dialog(v) {
      if (v) {
        this.tab = "tab1";
        this.saldoCliente = 0;
        if (this.editedProfile) {
          this.profile = { ...this.editedProfile };
          this.dtAniversario = Util.dateFormat(this.profile.aniversario);
        }
        this.createRules();
        this.getCarteira();
        this.getIndicacoes();
      } else {
        this.resetForm();
        this.editedProfile = null;
      }
    },
  },
  created() {
    this.init();
  },

  methods: {
    createRules() {
      this.dtAniversarioRules = [
        (v) => !!v || "Data de Aniversário é obrigatório",
        (v) => Util.isValidDate(v) || "Data inválida",
      ];
      this.telefoneRules = [(v) => !!v || "Telefone é obrigatório"];
      this.nomeRules = [(v) => !!v || "Nome é obrigatório"];
      this.emailRules = [(v) => !!v || "Email é obrigatório"];
      this.cpfRules = [(v) => !!v || "CPF é obrigatório"];
    },
    load() {
      this.loading = true;
      this.$store
        .dispatch("fetchClientes")
        .then((value) => {
          this.dataTableKey += 1;
          this.data = value;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCarteira() {
      this.loadingMovimentoCarteira = true;
      this.$store
        .dispatch("fetchCarteiraCliente", this.profile.idUser)
        .then((value) => {
          console.log(value);
          this.saldoCliente = value.saldo;

          for (var i = 0; i < value.movimentos.length; i++) {
            value.movimentos[i].data = Util.dateFormat(
              value.movimentos[i].data
            );
          }
          this.lstDatasMovimentoCarteira = value.movimentos;
          this.dtbMovimentosKey++;
        })
        .catch((err) => {
          console.log(err);
          this.dtbMovimentosKey++;
          this.saldoCliente = 0;
        })
        .finally(() => {
          this.loadingMovimentoCarteira = false;
        });
    },
    getIndicacoes() {
      this.loadingIndicacoes = true;
      this.indicacoes = [];
      this.$store
        .dispatch("fetchIndicacoesCliente", this.profile.idUser)
        .then((value) => {
          if (value.diretas) {
            for (var i = 0; i < value.diretas.length; i++) {
              let indiretas = value.indiretas.filter(function(v) {
                return v.idUserOrig == value.diretas[i].idUser;
              });
              this.indicacoes.push(value.diretas[i]);
              for (var j = 0; j < indiretas.length; j++) {
                this.indicacoes.push(indiretas[j]);
              }
            }
          }
          this.dtbIndicacoesKey++;
        })
        .catch((err) => {
          console.log(err);
          this.dtbIndicacoesKey++;
        })
        .finally(() => {
          this.loadingIndicacoes = false;
        });
    },
    // setListaMovCarteira(value) {
    //   if (value != null && value != "") {
    //     for (var i = 0; i < value.movimentos.length; i++) {
    //       let parsedDate = Util.dateFormat(value.movimentos[i].data);
    //       let filterList = this.lstDatasMovimentoCarteira.filter(function(v) {
    //         return v == parsedDate;
    //       });
    //       if (filterList.length == 0) {
    //         this.lstDatasMovimentoCarteira.push(parsedDate);
    //       }
    //     }
    //   }
    //   console.log(this.lstDatasMovimentoCarteira.length);
    // },

    editItem(item) {
      this.editedProfile = { ...item };
      this.dialog = true;
    },

    init() {
      this.load();
    },
    async deleteItem(item) {
      this.selectedId = item.id;
      this.deleteDialog = true;
    },

    onSave() {
      if (this.validateForm()) {
        this.profile.aniversario = this.dtAniversario;
        this.updateLoading = true;

        this.$store
          .dispatch("updateCliente", this.profile)
          .then(() => {
            this.$store.dispatch("setNotification", {
              type: "success",
              text: "Registro atualizado com sucesso!",
            });
            this.dialog = false;
            this.load();
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.updateLoading = false;
          });
      }
    },

    validateForm() {
      if (this.$refs.clienteForm.validate()) {
        return true;
      }
      return false;
    },
    resetForm() {
      if (this.$refs.clienteForm) {
        this.$refs.clienteForm.reset();
        this.dtAniversario = "";
      }
    },

    async ativar(item) {
      window.open(
        "https://loto-jr.web.app/ativar-conta?h=" +
          item.email +
          "|" +
          item.idUser,
        "_blank"
      );
    },
    resetpassword(item) {
      this.$store
        .dispatch("getUrlResetPassword", item.email)
        .then((value) => {
          console.log(value);
          if (value.type == "ok") {
            window.open(value.msg, "_blank");
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.updateLoading = false;
        });

      // window.open(
      //   "https://loto-jr.web.app/ativar-conta?h=" +
      //     item.email +
      //     "|" +
      //     item.idUser,
      //   "_blank"
      // );
    },

    onConfirmDelete(event) {
      console.log("deletando");
      http.delete("/api/v1/profile/delete/" + event).then((value) => {
        this.onCancelDelete();
        if (value.data.type == "ok") {
          this.$store.dispatch("setNotification", {
            type: "success",
            text: "Registro excluído com sucesso!",
          });
          this.load();
        } else {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: value.data.msg,
          });
        }
      });
    },

    onCancelDelete() {
      this.selectedId = 0;
      this.deleteDialog = false;
    },
    formatValue(value, tipo) {
      return (
        (tipo == "E" ? "+ " : "- ") +
        value.toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        })
      );
    },
  },
};
</script>

<style>
button.ma-0.v-btn.v-btn--flat.v-btn--icon.v-btn--round.theme--light.v-size--small {
  visibility: hidden;
}
</style>
